// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Gp1B","top":"styles_top__3Jmk6"};